import type { ParentProfile, StaffProfile, UserDetails, UserProfile } from '../types/models'

function isNonEmpty(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0
}

function isStaffProfileComplete(profile: UserProfile | null | undefined): boolean {
  if (!profile) return false
  const staff = profile as StaffProfile
  return isNonEmpty(staff.first_name) && isNonEmpty(staff.last_name)
}

function isParentProfileComplete(profile: UserProfile | null | undefined): boolean {
  if (!profile) return false
  const parent = profile as ParentProfile
  return (
    isNonEmpty(parent.first_name) &&
    isNonEmpty(parent.last_name) &&
    isNonEmpty(parent.phone_number) &&
    isNonEmpty(parent.address_line_1) &&
    isNonEmpty(parent.city) &&
    isNonEmpty(parent.state) &&
    isNonEmpty(parent.zip_code) &&
    isNonEmpty(parent.emergency_contact_name) &&
    isNonEmpty(parent.emergency_contact_phone)
  )
}

export function isUserProfileComplete(user: UserDetails | null | undefined): boolean {
  if (!user) return false
  if (user.role === 'PARENT') {
    return isParentProfileComplete(user.profile)
  }
  return isStaffProfileComplete(user.profile)
}
